import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseRangeFilter, FilterAttributeKey } from '../../models/Filter';
import { printOdometerFilterValue } from '../../utils/Filters';
import BaseFilterChip from './BaseFilterChip';

type RangeFilterChipProps = {
  filter: BaseRangeFilter;
};

const RangeFilterChip = ({ filter }: RangeFilterChipProps) => {
  // Dependencies
  const { t } = useTranslation();

  // Helper
  const getRangeTextValue = () => {
    switch (filter.attributeKey) {
      case FilterAttributeKey.YEAR:
        return filter.printValues();
      case FilterAttributeKey.ODOMETER:
        return printOdometerFilterValue(filter, t);
      default:
        return filter.printValues();
    }
  };

  // Derived state
  const chipText = getRangeTextValue();

  return <BaseFilterChip filter={filter} text={chipText} />;
};

export default RangeFilterChip;
